import { useEffect } from 'react';
import { App } from '@capacitor/app';

/**
 * Fires the callback when the app returns to the foreground.
 * Native: Capacitor App 'resume' + appStateChange(isActive). Web: the
 * visibilitychange event. Used to re-check registration status (feature #2)
 * and to flush activity on pause (feature #9).
 */
export function useAppResume(onResume: () => void, onPause?: () => void): void {
  useEffect(() => {
    let mounted = true;

    const stateHandlePromise = App.addListener('appStateChange', ({ isActive }) => {
      if (!mounted) return;
      if (isActive) onResume();
      else onPause?.();
    });

    const onVisibility = () => {
      if (document.visibilityState === 'visible') onResume();
      else onPause?.();
    };
    document.addEventListener('visibilitychange', onVisibility);

    return () => {
      mounted = false;
      void stateHandlePromise.then((h) => h.remove());
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [onResume, onPause]);
}
